import {
  h
} from "./anacapri-chunk.TOMZZDRF.js";

// src/utilities/AnacapriElement.ts
var AnacapriElement = class extends h {
};
AnacapriElement.version = "10.7.0";

export {
  AnacapriElement
};
